import { CommonModule }     from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AttachmentFileModelDirective }  from '../../attachments/attachment.file-model.directive';
import { BoxTogglerDirective }           from '../../core/directives/box-toggler.directive';
import { CopyToClipboardDirective }      from './copy-to-clipboard/copy-to-clipboard.component';
import { DatePickerButtonDirective }     from './date-picker-button/date-picker-button.directive';
import { FormSubmitValidatorDirective }  from './form-submit.validator.directive';
import { GiveFocusDesktopDirective }     from '../../core/directives/give-focus-desktop.directive';
import { GiveFocusDirective }            from '../../core/directives/give-focus.directive';
import { GridFilterDirective }           from '../../grids/grid.filter.directive';
import { NgEnterDirective }              from '../../../app/core/directives/ng-enter.directive';
import { SectionToggleDirective }        from '../../core/directives/section-toggle.directive';
import { TooltipDirective }              from './tooltip.directive';

@NgModule({
  declarations: [
    AttachmentFileModelDirective,
    BoxTogglerDirective,
    CopyToClipboardDirective,
    DatePickerButtonDirective,
    FormSubmitValidatorDirective,
    GiveFocusDesktopDirective,
    GiveFocusDirective,
    GridFilterDirective,
    NgEnterDirective,
    SectionToggleDirective,
    TooltipDirective
  ],
  entryComponents: [
    CopyToClipboardDirective
  ],
  exports: [
    // Third Party
    NgbTooltipModule,

    // Custom
    AttachmentFileModelDirective,
    BoxTogglerDirective,
    CopyToClipboardDirective,
    DatePickerButtonDirective,
    FormSubmitValidatorDirective,
    GiveFocusDesktopDirective,
    GiveFocusDirective,
    GridFilterDirective,
    NgEnterDirective,
    SectionToggleDirective,
    TooltipDirective
  ],
  imports: [
    // Angular
    CommonModule,

    // Third Party
    NgbTooltipModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class DirectivesModule {}
